import React, { useState, useEffect } from "react";
import Loading from "../components/loading";
import { storeLocalStorage } from "../function/functions";
import secureLocalStorage from "react-secure-storage";
import Logo from "../assets/images/logo.png";
import { useDispatch, useSelector } from "react-redux";
import { sendOtp } from "../store/features/webUtilitiesSlice";
import { LoginSocialApple, LoginSocialGoogle } from "reactjs-social-login";
import { useNavigate } from "react-router-dom";
import {
  AppleLoginButton,
  GoogleLoginButton,
} from "react-social-login-buttons";
import {
  APPLE_LOGIN_ENDPOINT,
  GOOGLE_CLIENT_ID,
  GOOGLE_LOGIN_ENDPOINT,
} from "../config/ApisCollection";
import axios from "axios";

const apple_response = {
  authorization: {
    code: "c772988a82cb14cd5878f6ab698757dfe.0.pxww.RKAfJMdGVVODNUCpPquWOw",
    id_token:
      "eyJraWQiOiJkTWxFUkJhRmRLIiwiYWxnIjoiUlMyNTYifQ.eyJpc3MiOiJodHRwczovL2FwcGxlaWQuYXBwbGUuY29tIiwiYXVkIjoiY29tLmZhc3RiZXR0ZXIuZ2xiIiwiZXhwIjoxNzQ0MDk3ODg1LCJpYXQiOjE3NDQwMTE0ODUsInN1YiI6IjAwMDc2Ni5iMzk5NjgyYWY5OWQ0MjZjYjg5NDNiN2JkZGZkMTVkZi4wNzA1IiwiY19oYXNoIjoiTW1Gb3VYaHVzRktvREtyVGhGUEt1USIsImVtYWlsIjoiYmN0ZzZwZHBkNEBwcml2YXRlcmVsYXkuYXBwbGVpZC5jb20iLCJlbWFpbF92ZXJpZmllZCI6dHJ1ZSwiaXNfcHJpdmF0ZV9lbWFpbCI6dHJ1ZSwiYXV0aF90aW1lIjoxNzQ0MDExNDg1LCJub25jZV9zdXBwb3J0ZWQiOnRydWV9.Zj3Dg8MzGZ34tHAQ71iWxar-LwjngvfHC8f5KAjs4wmGHCoDMeYaUdXeWmfar9BFclwi5ShD1VVEDF6iu4_zrCrEe0T4W001idQZ22XIOg_o5t7TU9DXIDXhqF9U6k5x6lIh60tZLZzFh2wWlIeyklm4OWBARRB_kWa4NHUAkkpS_P956X2vrlDoNAuODKDPQPD0DErX-wYU6uTEVzCfQam4gRCrv-TSgVdVUkZ18r1ooNgD2nPXIHtEvQzjlMbzpDFpfVRi3LTTrEztsoCSZQ9TvIqcxQ_gg83OmzpzuFjL808aSHSa7sfaRuMqXDH46S99tCOFZvmLUUeY7oRiEw",
    state: "origin:web",
  },
};

const Page = () => {
  const { errorMsg } = useSelector((state) => state.webUtilities);
  const REDIRECT_URI = window.location.href;

  const dispatch = useDispatch();
  let history = useNavigate();
  const [isLoading] = useState(false);
  const [userEmail, setUserEmail] = useState("");
  const [errorMsgs, setErrorMsg] = useState("");
  const [continueBtn, setContinueBtn] = useState(false);
  const [socialBtnStatus, setSocialBtnStatuts] = useState(true);

  // Social login
  const [provider, setProvider] = useState("");
  const [profile, setProfile] = useState(null);
  const [social_Cred, setSocialCred] = useState({
    google: {
      client_id: GOOGLE_CLIENT_ID,
    },
  });

  const validateEmail = (email) => {
    // Regular expression for validating email addresses
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(email);
  };

  // Google respones handler
  const handleSocialResponse = async (provider, data) => {
    setProvider(provider);

    if (data && data.email) {
      const request_body = {
        isSocial: provider,
        socialres: {
          access_token: data.access_token,
          scope: data.scope,
          sub: data.sub,
          name: data.name,
          given_name: data.given_name,
          email: data.email,
        },
      };
      const request_header = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      try {
        const response = await axios.post(
          GOOGLE_LOGIN_ENDPOINT,
          request_body,
          request_header
        );

        storeLocalStorage("accessToken", response.data.accessToken);
        storeLocalStorage("refreshToken", response.data.refreshToken);
        storeLocalStorage("isLoggedIn", "true");
        storeLocalStorage("userEmail", data.email);

        window.location.href = "/";
      } catch (error) {
        setSocialBtnStatuts(true);
        setErrorMsg(
          error.response.data.error.message || "Something went wrong"
        );
      }
    }
    // console.log(data);
  };

  const handleAppleResponse = async (provider, data) => {
    setProvider(provider);
    console.log(data);
    if (data && data?.authorization?.id_token) {
      const apple_base64Url = data?.authorization?.id_token?.split(".")[1];
      const apple_base64 = apple_base64Url
        .replace(/-/g, "+")
        .replace(/_/g, "/");
      const apple_jsonPayload = decodeURIComponent(
        atob(apple_base64)
          .split("")
          .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
          .join("")
      );

      // Parse JSON payload
      let apple_res_decoded = JSON.parse(apple_jsonPayload);
      const email = apple_res_decoded?.email;
      apple_res_decoded.id_token = data?.authorization?.id_token;

      const request_body = {
        isSocial: provider,
        socialres: {
          access_token: apple_res_decoded?.id_token,
          // scope: "name scope",
          // sub: apple_res_decoded?.sub,
          // email: email,
        },
      };
      console.log(request_body);
      const request_header = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      try {
        const response = await axios.post(
          APPLE_LOGIN_ENDPOINT,
          request_body,
          request_header
        );
        storeLocalStorage("accessToken", response.data.accessToken);
        storeLocalStorage("refreshToken", response.data.refreshToken);
        storeLocalStorage("isLoggedIn", "true");
        storeLocalStorage("userEmail", email);
        window.location.href = "/";
      } catch (error) {
        setSocialBtnStatuts(true);
        setErrorMsg(
          error.response.data.error.message || "Something went wrong"
        );
      }
    }
    // console.log(data);
  };

  useEffect(() => {
    if (secureLocalStorage.getItem("userEmail")) {
      setUserEmail(secureLocalStorage.getItem("userEmail"));
      setContinueBtn(true);
    }
  }, []);

  const handleEmailChange = (event) => {
    const enteredEmail = event.target.value;
    if (validateEmail(enteredEmail)) {
      setErrorMsg("");
      setContinueBtn(true);
      secureLocalStorage.setItem("userEmail", enteredEmail);
    } else {
      setErrorMsg("Please enter a valid email address.");
    }
    setUserEmail(enteredEmail);
  };

  if (isLoading) return <Loading />;
  const handleOtp = async () => {
    if (!continueBtn) {
      setErrorMsg("Please enter your valid email address.");
      return false;
    }
    try {
      const data = { email: userEmail };
      await dispatch(sendOtp(data));
      storeLocalStorage("userEmail", userEmail);
    } catch (error) {
      setErrorMsg(error.response.data.error.message || "Something went wrong");
    }
  };

  return (
    <div className="manlay bg-white">
      <div className="bodyly mt-16">
        <div
          className={`logo w-full flex justify-center top-0 z-30 fixed py-2 pt-3 left-0 bg-white`}
        >
          <img
            loading="lazy"
            src={Logo}
            alt="logo"
            className="h-auto w-32 z-30"
            width={100}
            height={30}
          />
        </div>
        {socialBtnStatus ? (
          <div className="w-full sm:mt-28 mt-20 mb-10">
            <div className="text-center mb-3">
              <h1 className="title font-semibold text-3xl">Login</h1>
              <p className="font-normal text-sm">Unlock Your Best Self</p>
            </div>
            <input
              type="email"
              name="email"
              value={userEmail || ""}
              onChange={handleEmailChange}
              placeholder="your@email.com"
              className="inputbox mt-5 sm:text-base sm:px-4 sm:py-4 py-3 px-4 text-sm rounded-xl"
            />

            <div className="flex justify-center">
              <LoginSocialGoogle
                isOnlyGetToken={false}
                client_id={social_Cred.google.client_id || ""}
                onLoginStart={() => {
                  setSocialBtnStatuts(false);
                }}
                scope="profile email"
                onResolve={({ provider, data }) => {
                  handleSocialResponse(provider, data);
                }}
                onReject={(err) => {
                  setSocialBtnStatuts(true);
                }}
              >
                <GoogleLoginButton
                  className={
                    "w-1/2 text-[14px] bg-[#fffcfb] border border-[#efeded82] text-black px-4 py-2.5 rounded-sm flex justify-center items-center shadow-none"
                  }
                />
              </LoginSocialGoogle>

              <LoginSocialApple
                client_id={"com.fastbetter.glb" || ""}
                scope={"name email"}
                redirect_uri={REDIRECT_URI}
                onLoginStart={() => {
                  setSocialBtnStatuts(false);
                }}
                onResolve={({ provider, data }) => {
                  console.log(provider);
                  console.log(data);
                  handleAppleResponse("apple", data);
                }}
                onReject={(err) => {
                  console.log(err);
                  setSocialBtnStatuts(true);
                }}
              >
                <AppleLoginButton
                  className={
                    "w-1/2 text-[14px] bg-[#fffcfb] border border-[#efeded82] text-black px-4 py-2.5 rounded-sm flex justify-center items-center shadow-none"
                  }
                />
              </LoginSocialApple>
            </div>
            <p className="text-sm text-[red] text-center">
              {errorMsg || errorMsgs}
            </p>
            <div className="btmain w-11/12 mt-10 mx-auto text-center">
              <div
                onClick={handleOtp}
                className={`sm:w-full w-10/12 mx-auto font-medium text-xl bottontex bottonly sm:py-4 py-3 ${
                  continueBtn ? "bottonlyac" : "bg-gray-300"
                }`}
              >
                Send OTP
              </div>
              <div className="tex mt-6">
                <span className="tex">Don’t have an account?</span>
                <a href="https://fastbetter.com" className="loginbotm">
                  Begin your journey
                </a>
              </div>
            </div>
          </div>
        ) : (
          <>
            <div className="manlay content-center bg-white">
              <div className="text-center mb-3">
                {/* <h1 className="title font-semibold text-3xl">Please wait...</h1> */}
                <p className="font-normal text-sm">Please wait...</p>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
export default Page;
